/**
 * Returns a hash code from a string
 * @param  {String} code The string to hash
 * @return {Number} A 32-bit integer
 */
export default function hashCode(code: string): number {
  let hash = 0

  for (let i = 0, len = code.length; i < len; i++) {
    const char = code.charCodeAt(i)
    hash = (hash << 5) - hash + char
    hash |= 0 // Convert to 32bit integer
  }

  return hash
}
